import api from '@shared/services/api';

export const educationService = {
    createDegree: async (degreeData) => {
        try {
            const formattedData = {
                education: degreeData.education,
                code: degreeData.code,
                ordno: degreeData.ordno,
                active: degreeData.active,
                degreeLevel: degreeData.degreeLevel,
                addCode: degreeData.addCode,
                addLevel: degreeData.addLevel
            };
            const response = await api.post('/degree-levels', formattedData);
            return response.data;
        } catch (error) {
            console.error('Error creating degree:', error);
            throw error;
        }
    },

    updateDegree: async (degreeId, degreeData) => {
        try {
            const formattedData = {
                education: degreeData.education,
                code: degreeData.code,
                ordno: degreeData.ordno,
                active: degreeData.active,
                degreeLevel: degreeData.degreeLevel,
                addCode: degreeData.addCode,
                addLevel: degreeData.addLevel
            };
            const response = await api.put(`/degree-levels/${degreeId}`, formattedData);
            return response.data;
        } catch (error) {
            console.error('Error updating degree:', error);
            throw error;
        }
    },

    deleteDegree: async (degreeId) => {
        try {
            await api.delete(`/degree-levels/${degreeId}`);
            return true;
        } catch (error) {
            console.error('Error deleting degree:', error);
            throw error;
        }
    },

    getDegrees: async ({ searchQuery, searchType, pageNumber = 0, pageSize = 10, sortBy = 'ordno', sortDir = 'asc', ...searchParams }) => {
        try {
            const params = {
                page: pageNumber,
                size: pageSize,
                sortBy: sortBy,
                sortOrder: sortDir,
            };

            // Handle multiple search parameters
            if (searchQuery && typeof searchQuery === 'object') {
                // Add each search parameter directly to params
                Object.entries(searchQuery).forEach(([key, value]) => {
                    if (value && value.trim()) {
                        params[key] = value.trim();
                    }
                });
            } else if (searchQuery && typeof searchQuery === 'string') {
                // Handle legacy string search query
                if (searchType) {
                    params[searchType] = searchQuery.trim();
                }
            }

            // Add any additional search parameters
            Object.entries(searchParams).forEach(([key, value]) => {
                if (value && value.trim()) {
                    params[key] = value.trim();
                }
            });

            const response = await api.get('/degree-levels', { params });
           
            const { _embedded, page } = response.data;
            
            if (!_embedded || !_embedded.degreeLevelDTOList) {
                return {
                    content: [],
                    totalPages: 0,
                    totalElements: 0,
                    pageNumber: pageNumber
                };
            }

            return {
                content: _embedded.degreeLevelDTOList,
                totalPages: page.totalPages,
                totalElements: page.totalElements,
                pageNumber: page.pageable?.pageNumber || pageNumber
            };
        } catch (error) {
            console.error('Error fetching degrees:', error);
            throw error;
        }
    },

    getDegreeById: async (id) => {
        try {
            const response = await api.get(`/degree-levels/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching degree:', error);
            throw error;
        }
    }
};
